import BreadcrumbItem from "./BreadcrumbItem";

const Breadcrumb = ({breadcrumb}) => {
    return (
        <nav className="pl-7 flex" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-[12px]">
                {breadcrumb.map((item, index) => {
                    let isTop = (index === 0) ? true : false;
                    let link = (index === breadcrumb.length - 1) ? '' : item.link;
                    let handleNavigate = item.handleNavigate !== undefined ? item.handleNavigate : '';
                    return <BreadcrumbItem key={index} menu={item.menu} link={link} top={isTop} handleNavigate={handleNavigate} />
                })}
            </ol>
        </nav>
    );
}

export default Breadcrumb;